import { combineReducers } from 'redux';
import reactionReducer from './reaction';
import tagsReducer from './tags';
import followReducer from './follow';
import userDetailsReducer from './user-details';
import featuredAthletesReducer from '../featuredAthletes';

const rootReducer = combineReducers({
  reaction: reactionReducer,
  tags: tagsReducer,
  follow: followReducer,
  userDetails: userDetailsReducer,
  featuredAthletes: featuredAthletesReducer,
});

export default rootReducer;
